import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

// The JAP mark: J, the giving chevron, P. One shared geometry for every size.
export const LOGO_VIEWBOX = '0 0 272 98'
export const LOGO_WIDTH = 272
export const LOGO_J = 'M47 0H70V84L56 98H14L0 84V52H23V75H47Z'
export const LOGO_CHEVRON = 'M86 23V0L181.5 25.5V71.5L86 98V75.5L181.5 49L86 23Z'
export const LOGO_P = 'M197.5 0H257.5L271.5 14V50L257.5 64H220.5V98H197.5ZM220.5 23V41H248.5V23Z'
export const CHEVRON_PATH = 'M0 23V0L95.5 25.5V71.5L0 98V75.5L95.5 49L0 23Z'

interface ChevronProps {
    className?: string
}

export const Chevron: FC<ChevronProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 96 98'
            aria-hidden='true'
            focusable='false'
            className={cn('shrink-0', className)}
            fill='currentColor'
        >
            <path d={CHEVRON_PATH} />
        </svg>
    )
}

interface LogotypeProps {
    className?: string
    chevronClassName?: string
    title?: string
}

// J and P take the current text colour, the chevron can be tinted separately.
export const Logotype: FC<LogotypeProps> = ({ className, chevronClassName, title }): ReactNode => {
    return (
        <svg
            viewBox={LOGO_VIEWBOX}
            role={title ? 'img' : undefined}
            aria-label={title}
            aria-hidden={title ? undefined : 'true'}
            focusable='false'
            className={cn('shrink-0', className)}
            fill='currentColor'
        >
            <path d={LOGO_J} />
            <path d={LOGO_CHEVRON} className={chevronClassName} />
            <path d={LOGO_P} fillRule='evenodd' />
        </svg>
    )
}
